/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

/** Figma-style X for off state (user SVG duplicated check; this is a proper close mark). */
const ToggleCloseIcon = ({ className = '', size = 12 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M1.5 1.5L6.5 6.5M6.5 1.5L1.5 6.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

ToggleCloseIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
};

export default ToggleCloseIcon;
